import { AxiosResponse } from 'axios';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AccountAPI } from 'client/api.config';
import { getStatusCode } from 'client/ErrorHandler';
import { getNextDayString, splitDateRangeIntoChunks } from 'store/utils';
import { ExportsTypes } from './types';
import ExportsActions from './actions';
import { StatementList } from '../statements/types';

const { request, success, failure } = ExportsActions;

export function* downloadInBatches({
  payload,
}: ReturnType<typeof request>): Generator<any, void, any> {
  try {
    const { periodStart, periodEnd, reportType, document } = payload;
    const start = periodStart;
    const end = periodEnd ?? periodStart;
    const datesChunks = splitDateRangeIntoChunks(start, end);

    const apiCalls = Array(datesChunks.length - 1)
      .fill(0)
      .map((_, index) => {
        // start intervals by adding one day, expect first date
        const firstDate =
          index > 0 ? getNextDayString(datesChunks[index]) : datesChunks[0];
        let endpoint = `/v1/accounts/statement?reportType=${reportType}&periodStart=${firstDate}&periodEnd=${
          datesChunks[index + 1]
        }&offset=0&limit=9999999999`;

        if (document) {
          endpoint += `&document=${document}`;
        }

        const apiCall = call(AccountAPI.get, endpoint);

        return apiCall;
      });

    const responses = yield all(apiCalls);

    let statements: StatementList = [];
    responses.forEach(({ data }: AxiosResponse) => {
      statements = [...statements, ...data.Records];
    });

    yield put(success({ statements }));
  } catch (error) {
    const statusCode = getStatusCode(error);
    yield put(failure(statusCode));
  }
}

export default function* (): Generator<any, void, any> {
  yield all([takeLatest(ExportsTypes.ExportsRequest, downloadInBatches)]);
}
